export const applicationName = 'BH.web.Angular.UI';
